import React from 'react';

import {Tooltip} from '@optimaxdev/design-system';
import {Icon, Cart} from '@optimaxdev/icons';
import classNames from 'classnames';

import {PATH_TO_CART} from 'desktop/pages/checkout/constants/checkout';

import {useGetQuoteItemsCartDataQueryKey} from 'desktopMiniCart/constants';
import {useGetQuoteItemsCartData} from 'hooks/getQuoteItemsCart/useGetQuoteItemsCart';

import s from './cartIcon.scss';

/**
 * Link to the cart page with counter of added items to the cart.
 * @returns {React.FC<PropsType>} CartIcon component
 */
export const CartIcon: React.FC = () => {
    const {data} = useGetQuoteItemsCartData({
        queryKey: useGetQuoteItemsCartDataQueryKey,
    });

    return (
        <div className={s.cart}>
            <Tooltip
                arrowBorderColor="#0f0f0f"
                arrowColor="#0f0f0f"
                closeTrigger="hover"
                content={<div className={s.content}>Cart</div>}
                elevation={1}
                openTrigger="hover"
                position="bottom"
                size="small"
                tooltipAnimation="moving"
                tooltipBorderColor="#0f0f0f"
            >
                <a className={classNames(s.container)} href={PATH_TO_CART}>
                    <Icon className={s.iconCart} icon={Cart} strokeWidth={2} />
                    <span className={classNames(s.counts, s.animated)}>{data?.count}</span>
                </a>
            </Tooltip>
        </div>
    );
};
